import { Injectable } from '@angular/core';
import { Group, UserGroup } from './../model/model';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
@Injectable()
export class GroupService {
  public queryEndPoint = 'query-api/Group';

  constructor(private http: HttpClient) { }

  get = (id: string) => this.http.get<Group>(`${this.queryEndPoint}/${id}`);
  getAll = () => this.http.get<UserGroup[]>(`${this.queryEndPoint}`);
}
